module.exports = __webpack_public_path__ + "static/media/prick_HMPG_survey_image_1000.fa4a572a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/prick_HMPG_survey_image_1000.jpg
// module id = 358
// module chunks = 0